module.exports = __webpack_public_path__ + "static/media/circle-formation.7663549a.svg";